import { FC } from 'react';
import ExploreGptsHandler from '../Components/ExploreGpt/ExploreGptsHandler';

export const PageExploreGpts: FC = () => {
    return <ExploreGptsHandler />;
};
